import { useEffect } from 'react';
import { Box, Typography, CircularProgress, Alert, Button, Container } from '@mui/material';
import { useConfirmEmail } from '@/lib/api/auth.ts';
import { PublicOnlyGuard } from '@/features/auth/PublicOnlyGuard.tsx';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ConfirmEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const { mutate: confirmEmail, isError, isPending, isSuccess } = useConfirmEmail();

  useEffect(() => {
    if (!token) {
      return;
    }

    confirmEmail(token, {
      onSuccess: () => {
        setTimeout(() => navigate('/login'), 3000);
      },
    });
  }, [confirmEmail, navigate, token]);

  return (
    <PublicOnlyGuard>
      <Container maxWidth="sm">
        <Box mt={8} textAlign="center">
          {isPending && (
            <>
              <CircularProgress />
              <Typography variant="h6" mt={2}>
                Confirmando tu email...
              </Typography>
            </>
          )}

          {isSuccess && (
            <Alert severity="success">
              ¡Tu correo ha sido confirmado! Serás redirigido al login en unos segundos...
            </Alert>
          )}

          {(isError || !token) && (
            <>
              <Alert severity="error" sx={{ mb: 2 }}>
                El enlace de confirmación no es válido o ya ha expirado.
              </Alert>
              <Button variant="contained" onClick={() => navigate('/login')}>
                Ir al login
              </Button>
            </>
          )}
        </Box>
      </Container>
    </PublicOnlyGuard>
  );
}
